import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { PlatformErrorBoundary } from './components/PlatformErrorBoundary'
import './styles/globals.css'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PlatformErrorBoundary>
      <App />
    </PlatformErrorBoundary>
  </React.StrictMode>,
)



